﻿$.fn.dxCtrlEmailPrevisualisationAcidClient = function custom_dxCtrlEmailPrevisualisationAcidClient(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlemailprevisualisationacidclient dx-ctrl");
        this.createInstance(new cdxCtrlEmailPrevisualisationAcidClient(this, option));
    }
    return this;
}

window.cdxCtrlEmailPrevisualisationAcidClient = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var jauge = null
    var $DivImg = null
    var $DivDetail = null;
    var img = null;
    function mConstruit() {
        container.empty()
        jauge = null
        $DivImg = null
        $DivDetail = null;
        img = null;

        var height = null
        if (option.cropped) {
            height = option.zoom * 30
            if (height > 500) height = 500
        }

        var width = option.zoom * 50
        var fontSize = option.zoom * 20
        if (fontSize > 150) fontSize = 150
        if (fontSize < 70) fontSize = 70

        container.css({
            width: width + "px",
            overflow: "hidden",
            border: theme.border,
            "background-color": "white",
            "border-radius": "5px"
        })
        container.off("click")
        container.on("click", function () {
            if (img != null) {
                var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                    fullScreen: true,
                    showTitle: false,
                    contentTemplate: function (contentElement) {
                        contentElement.css("display", "relative")
                        dxBtClose = $("<div style='position:absolute;z-index:101;top:2px;right:5px'/>").appendTo(contentElement).dxCtrlButton({
                            icon: 'fas fa-times',
                            width: HeightButton,
                            height: HeightButton,
                            onClick: function (e) {
                                popup.hide()
                            }
                        }).dxCtrlButton("instance");
                        var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
                        dxScroll.content().css("text-align","center")
                        img = $("<img src='" + option.data.screenshots.default + "' style='max-width:100%;'/>").appendTo(dxScroll.content())
                        if (option.data.category == "Mobile") img.css({ "width":"100%","max-width": "500px"})

                        var $DivTxt = $("<div style='text-align:center;padding:5px;color:black;background-color:gray;font-size:" + fontSize + "%;'/>").appendTo(contentElement)
                        $("<div style='font-weight:bold;'>" + option.data.display_name + "</div>").appendTo($DivTxt)
                        $("<div>" + option.data.os + "</div>").appendTo($DivTxt)

                        window.setTimeout(function () {
                            dxScroll.element().css("height", "calc(100% - " + $DivTxt.innerHeight() + "px)")
                        }, 20)
                    }
                }).dxCtrlPopupBase("instance")
                popup.show()
            }
        })

        jauge = $("<div/>").appendTo(container).dxCtrlJauge({
            width: 50,
            height: 50
        }).dxCtrlJauge("instance")
        jauge.mShow()

        option.data.container = container
        if (!option.data.checked) option.data.container.css("display", "none")
        $DivImg = $("<div style='width:100%;" + ((height) ? "height:" + height + "px;overflow:hidden;" : "") + "' class='imgpreview'/>").appendTo(container)
        var $DivImgContainer = null
        if (height) {
            option.data.dxScrollImg = $("<div/>").appendTo($DivImg).dxScrollView({}).dxScrollView("instance")
            $DivImgContainer = option.data.dxScrollImg.content()
        }
        else {
            option.data.dxScrollImg = null
            $DivImgContainer = $("<div/>").appendTo($DivImg)
        }

        $DivDetail = $("<div style='text-align:center;padding:5px;color:black;background-color:gray;font-size:" + fontSize + "%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;'/>").appendTo(container)
        $("<div style='font-weight:bold;overflow:hidden;text-overflow:ellipsis;'>" + option.data.display_name + "</div>").appendTo($DivDetail)
        $("<div style='overflow:hidden;text-overflow:ellipsis;'>" + option.data.os + "</div>").appendTo($DivDetail)

        switch (option.data.status) {
            case "Complete":
                img = $("<img style='width:100%;'/>").appendTo($DivImgContainer)
                img.on("load", function () {
                    jauge.mHide()
                    //option.data.dxScrollImg.option("disabled", option.zoom < 8)
                    container.css("cursor", "pointer")
                })
                img.on("error", function () {
                    jauge.mHide()
                    img.remove()
                    img = null;
                    $("<i class='fas fa-triangle-exclamation' style='color:red;font-size:60px;'></i>").appendTo($DivImgContainer)
                    //option.data.dxScrollImg.option("disabled", true)
                })
                if (option.zoom >= 8) { img.attr("src", option.data.screenshots.default + "?d=" + (new Date()).getTime()) }
                else { img.attr("src", option.data.thumbnail + "?d=" + (new Date()).getTime()) }
                break;
            case "Processing": case "Pending":
                //$Img = $("<img src='" + parametre.urldispatch + "/img/jauge2.svg' style='width:60px;margin-top:10px;'/>").appendTo(option.data.dxScrollImg.content())
                //$Img.attr("title", "Image non encore générée<br/>Cliquer pour réessayer de la charger immédiatement")
                //$Img.on("click", function (e) {
                //    jauge.mShow()
                //    e.event.stopPropagation()
                //    mDemandeReloadImage(function (status) {
                //        if (status == "Processing" || status == "Pending") { mNotify("L'image n'a pas été encore générée", "warning", 1000) }
                //        else { mNotify("L'image a été générée", "success", 1000) }
                //    })
                //})
                $("<div style='margin-top:10px;'/>").appendTo($DivImgContainer).dxCtrlButton({
                    icon: 'fas fa-clock-rotate-left',
                    width: HeightButton,
                    height: HeightButton,
                    txtTooltip: "Image non encore générée<br/>Cliquer pour réessayer de la charger",
                    onClick: function (e) {
                        jauge.mShow()
                        e.event.stopPropagation()
                        option.onReloadImage(option.data.id, function (data) {
                            option.data = data
                            if (option.data.status == "Processing" || option.data.status == "Pending") { mNotify("L'image n'a pas été encore générée", "warning", 1000) }
                            else { mNotify("L'image a été générée", "success", 1000) }
                            mConstruit()
                        })
                    }
                })
                //if (option.data.dxScrollImg)      option.data.dxScrollImg.option("disabled", true)
                jauge.mHide()
                break;
            case "Bounced":
                $("<i class='fas fa-triangle-exclamation' style='color:red;font-size:60px;margin-top:10px;'></i>").appendTo($DivImgContainer)
                //if (option.data.dxScrollImg)     option.data.dxScrollImg.option("disabled", true)
                jauge.mHide()
                break;
        }
    }

    //function mDemandeReloadImage(funcFin) {
    //    option.onReloadImage(option.data.id, function (data) {
    //        option.data = data
    //        if (typeof funcFin != 'undefined') funcFin(option.data.status)
    //        if (option.data.status == "Processing" || option.data.status == "Pending") { mNotify("L'image n'a pas été encore générée", "warning", 1000) }
    //        else { mNotify("L'image a été générée", "success", 1000) }
    //        mConstruit()
    //    })
    //}

    this.mChangeZoom = function (zoom) {
        if (img != null) {
            if (zoom < 8 && option.zoom >= 8) { img.attr("src", option.data.thumbnail) }
            else if (zoom >= 8 && option.zoom < 8) { img.attr("src", option.data.screenshots.default) }
        }

        option.zoom = zoom
        var height = null
        if (option.cropped) {
            var height = option.zoom * 30
            if (height > 500) height = 500
        }
        var width = option.zoom * 50
        var fontSize = option.zoom * 20
        if (fontSize > 150) fontSize = 150
        if (fontSize < 70) fontSize = 70

        container.css({ width: width + "px" })
        $DivImg.css({ "height": ((height) ? height + "px" : "") })
        $DivDetail.css({ "font-size": fontSize + "%" })
        //option.data.dxScrollImg.option("disabled", option.zoom < 8)
    }

    this.mChangeCrop = function (crop) {
        option.cropped = crop
        mConstruit()
    }

    this.element = function () { return container }

    mConstruit();
}